import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Cashback({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M2.76211 6.66692L2.52807 7.07229L1.96856 4.98419L0.680664 5.32929L1.65673 8.97202C1.75203 9.32766 2.11758 9.53872 2.47323 9.44343L6.11596 8.46736L5.77087 7.17946L3.68277 7.73896L3.96808 7.24479L3.96737 7.24438C5.59446 4.50234 8.58328 2.66666 12.0001 2.66666C17.1547 2.66666 21.3334 6.84534 21.3334 12C21.3334 17.1547 17.1547 21.3333 12.0001 21.3333C6.84542 21.3333 2.66674 17.1547 2.66674 12H1.33341C1.33341 17.891 6.10904 22.6667 12.0001 22.6667C17.8911 22.6667 22.6667 17.891 22.6667 12C22.6667 6.10896 17.8911 1.33333 12.0001 1.33333C8.05107 1.33333 4.60414 3.47964 2.76083 6.66618L2.76211 6.66692Z"
        fill={iconColor}
      />
      <Path
        d="M10.6667 17.1084V18.6667H12.0001V5.33333H10.6667V6.82338C10.1258 6.95307 9.61379 7.16394 9.18378 7.45832C8.5153 7.91597 8.00008 8.61515 8.00008 9.52885C8.00008 10.6745 8.57578 11.4238 9.35485 11.9111C9.74822 12.1572 10.2033 12.3431 10.6667 12.4954V15.7204C10.4802 15.6593 10.3046 15.5896 10.1444 15.5128C9.54909 15.2278 9.34922 14.9401 9.32234 14.7944L8.01114 15.0364C8.1597 15.8416 8.88089 16.3861 9.56849 16.7154C9.90334 16.8758 10.2759 17.008 10.6667 17.1084ZM10.6667 11.0791V8.20812C10.3889 8.2999 10.141 8.41885 9.93699 8.55853C9.51995 8.84404 9.33341 9.17504 9.33341 9.52885C9.33341 10.1265 9.59104 10.4862 10.062 10.7808C10.2406 10.8925 10.4433 10.9901 10.6667 11.0791Z"
        fill={iconColor}
      />
      <Path
        d="M14.661 16.8382C14.2612 17.0569 13.8058 17.1936 13.3334 17.2666V15.9116C13.5948 15.8559 13.8276 15.7743 14.0211 15.6684C14.4324 15.4435 14.6667 15.1179 14.6667 14.5985C14.6667 14.3276 14.5983 14.1383 14.4965 13.9893C14.389 13.832 14.2188 13.6827 13.9649 13.5399C13.7782 13.4349 13.5667 13.3437 13.3334 13.2598V11.856C13.7879 11.9956 14.2341 12.1616 14.6186 12.3778C14.9897 12.5866 15.3403 12.8608 15.5975 13.2372C15.8602 13.6219 16.0001 14.0767 16.0001 14.5985C16.0001 15.6647 15.445 16.4093 14.661 16.8382Z"
        fill={iconColor}
      />
      <Path
        d="M13.3334 8.21095V6.82525C14.4662 7.10315 15.512 7.7681 15.9588 8.97901L14.708 9.44063C14.4954 8.86455 13.9915 8.44432 13.3334 8.21095Z"
        fill={iconColor}
      />
    </Svg>
  );
}
